import {
  transform as _transform,
  isEqual as _isEqual,
  isObject as _isObject
} from "lodash";

import { not } from "ramda";

const formatQuery = keys => {
  const query = Object.keys(keys)
    .map(key => {
      return {
        ...((keys[key] || (keys[key] !== undefined && keys[key] !== null)) && {
          [key]: keys[key]
        })
      };
    })
    .filter(data => Object.keys(data).length >= 1);
  return Object.assign({}, ...query);
};

const formatRequestBody = keys => {
  const query = Object.keys(keys)
    .map(key => {
      return {
        ...((keys[key] || (keys[key] !== undefined && keys[key] !== null)) && {
          [key]: keys[key]
        })
      };
    })
    .filter(data => Object.keys(data).length >= 1);
  return Object.assign({}, ...query);
};

const _objectDiffer = (modified, original) => {
  function changes(modified, original) {
    return _transform(modified, function(result, value, key) {
      if (not(_isEqual(value, original[key]))) {
        result[key] =
          _isObject(value) && _isObject(original[key])
            ? changes(value, original[key])
            : value;
      }
    });
  }
  return changes(modified, original);
};

export const Helper = {
  formatQuery,
  formatRequestBody,
  _objectDiffer
};
